"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFieldWrapper = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const text_helpers_1 = require("../../helpers/text-helpers");
//import {TextFieldAppearance} from '@volkswagen-onehub/components-core/dist/text-fields/shared';
const React = __importStar(require("react"));
const utils_1 = require("../utils");
const StyledLabel = components_core_1.styled.label `
  display: block;
  width: 100%;
  position: relative;
`;
const StyledCustomLabelText = components_core_1.styled.p `
  font-family: 'vw-head', Helvetica, Arial, sans-serif;
  font-size: 20px;
  font-weight: 300;
  color: #000000;
  margin: 0;
  padding: 0 ${props => (props.hasIcon ? props.theme.size.static400 : 0)};
`;
const StyledLabelText = components_core_1.styled.p `
  font-size: ${props => props.theme.fonts.copy[100].fontSize};
  color: ${utils_1.getLabelIconColor};
  margin: 0;
  padding: 0 ${props => (props.hasIcon ? props.theme.size.static400 : 0)};
`;
const AdditionalInfo = components_core_1.styled.div `
  display: flex;
  flex-direction: row;
  justify-content: ${props => props.errorShouldBeVisible ? 'space-between' : 'flex-end'};
`;
const StyledErrorText = components_core_1.styled.p `
  display: block;
  color: ${props => props.theme.colors.signal.error};
  font-size: ${props => props.theme.fonts.copy[100].fontSize};
  margin: 0;
`;
const StyledCharacterCounterWrapper = components_core_1.styled.span `
  display: flex;
  justify-content: flex-end;
  color: ${props => props.theme.colors.content.tertiary};
`;
const StyledContainer = components_core_1.styled.div `
  position: relative;
`;
const StyledIcon = components_core_1.styled.div `
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: ${utils_1.getLabelIconColor};
  ${props => props.rightAlign && 'right: 0;'}
  & > svg {
    ${props => props.rightAlign &&
    `fill: ${props.rightIconColor ? props.rightIconColor : '#96a3a8'};`}
  }
`;
const StyledIconBtn = components_core_1.styled.button `
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: ${utils_1.getLabelIconColor};
  border: 0;
  padding: 0;
  background: none;
  cursor: pointer;
  ${props => props.rightAlign && 'right: 0;'}

  &:focus {
    outline: none;
  }

  & > svg {
    ${props => props.rightAlign &&
    `fill: ${props.rightIconColor ? props.rightIconColor : '#96a3a8'};`}
  }
`;
const CharacterCounter = ({ maxLength, value = '' }) => (React.createElement(StyledCharacterCounterWrapper, { "aria-hidden": true },
    React.createElement(components_core_1.Text, { color: components_core_1.TokenTextColor.inherit, appearance: components_core_1.TokenTextAppearance.copy100 },
        value.length,
        "/",
        maxLength)));
const TextFieldWrapper = props => {
    const { additionalFeedback, appearance, children, errorText, label, useCustomZipText, maxLength, required, value, icon, rightIcon, rightIconColor, rightIconBtnFun, ariaLabel } = props;
    const errorShouldBeVisible = Boolean(appearance === text_helpers_1.TextAreaAppearance.Error && errorText);
    const additionalInfoShouldBeVisible = errorShouldBeVisible || maxLength;
    return (React.createElement(StyledLabel, { className: "input-field-wrapper" },
        useCustomZipText ? (React.createElement(StyledCustomLabelText, { appearance: appearance, hasIcon: Boolean(icon), className: "input-field-label" },
            label,
            required && '*')) : (React.createElement(StyledLabelText, { appearance: appearance, hasIcon: Boolean(icon), className: "input-field-label input-required" },
            label,
            required && '*')),
        icon ? (React.createElement(StyledContainer, { className: "input-field-icon" },
            React.createElement(StyledIcon, { appearance: appearance }, icon),
            children)) : rightIcon ? (React.createElement(StyledContainer, { className: "input-field-icon field-right-icon" },
            rightIconBtnFun ? (React.createElement(StyledIconBtn, { appearance: appearance, rightAlign: true, rightIconColor: rightIconColor, onClick: () => rightIconBtnFun(), className: "input-field-icon-button", "aria-label": ariaLabel }, rightIcon)) : (React.createElement(StyledIcon, { appearance: appearance, rightAlign: true, rightIconColor: rightIconColor, className: "input-field-simple-icon" }, rightIcon)),
            children)) : (React.createElement(React.Fragment, null, children)),
        additionalInfoShouldBeVisible && (React.createElement(AdditionalInfo, { errorShouldBeVisible: errorShouldBeVisible },
            errorShouldBeVisible && (React.createElement(StyledErrorText, { "aria-live": "assertive", "aria-relevant": "all", className: "input-field-error" }, errorText)),
            maxLength && (React.createElement(CharacterCounter, { appearance: appearance, value: value, maxLength: maxLength })))),
        additionalFeedback));
};
exports.TextFieldWrapper = TextFieldWrapper;
exports.TextFieldWrapper.displayName = 'TextFieldWrapper';
